import type { fuelTypeMessagesScope } from '../../Services/Vehicle/Vehicle.messages';
import { type MessageOptions, transformOptionsByMessageIds } from './TransformOptionsByMessageId';

export type FuelTypeMessageId = keyof typeof fuelTypeMessagesScope;

const FUEL_TYPES_BY_MESSAGE_ID: Record<FuelTypeMessageId, MessageOptions> = {
  petrol: {
    ids: ['petrol'],
    label: 'Petrol',
  },
  diesel: {
    ids: ['diesel'],
    label: 'Diesel',
  },
  hybrid: {
    ids: ['hybrid'],
    label: 'Hybrid',
  },
  electric: {
    ids: ['electric'],
    label: 'Electric',
  },
};

const FUEL_TYPES = transformOptionsByMessageIds(FUEL_TYPES_BY_MESSAGE_ID);

export { FUEL_TYPES };
